import request from '@/api/request'

//人才列表
export function recommendlist(data) {
    return request({
        url: '/api/director/user/list',
        method: 'GET',
        params: data
    })
}

//人才更多列表
export function morelist(data) {
    return request({
        url: '/api/director/user/list',
        method: 'GET',
        params: data
    })
}

//人才主页信息
export function recommendinfo(data) {
    return request({
        url: '/api/user/info',
        method: 'GET',
        params: data
    })

    
}

//背景图获取
export function themeImg(data) {
    return request({
        url: '/web/user/get/themeImg',
        method: 'GET',
        params: data
    })
    
}




export function recommendupdate(data) {
    return request({
        url: '/web/recommend/update',
        method: 'POST',
        data
    })
}




export function userDirectorUpdate(data) {
    return request({
        url: '/web/user/director/update',
        method: 'POST',
        data
    })
}


//人才检索列表
export function recommendsearch(data) {
    return request({
        url: '/api/user/select',
        method: 'GET',
        params: data
    })
}

//切换身份
export function userswitchUser(data) {
    return request({
        url: '/api/user/switchUser',
        method: 'POST',
        data
    })
}

//首页banner
export function bannerimage(data) {
    return request({
        url: '/api/banner/list',
        method: 'GET',
        params: data
    })
}

//主管主页
export function userdirectorinfo(data) {
    return request({
        url: '/api/director/info',
        method: 'GET',
        params: data
    })
}


//好友列表
export function peoples(data) {
    return request({
        url: '/api/friend/list',
        method: 'GET',
        params: data
    })
}

//推广人员列表
export function extension_peoples(data) {
    return request({
        url: '/api/extension/list',
        method: 'GET',
        params: data
    })
}


//我关注的列表
export function follow_peoples(data) {
    return request({
        url: '/api/follow/list',
        method: 'GET',
        params: data
    })
}

//关注我的列表
export function fans_peoples(data) {
    return request({
        url: '/api/follow/fans/list',
        method: 'GET',
        params: data
    })
}






//个人简历列表
export function userResumeList(data) {
    return request({
        url: '/web/user/resume/list',
        method: 'GET',
        params: data
    })
}

//个人简历详情
export function userResumeInfo(data) {
    return request({
        url: '/api/member/resume/show',
        method: 'GET',
        params: data
    })
}



//个人简历修改
export function userResumeUpdate(data) {
    return request({
        url: '/api/member/resume-store',
        method: 'POST',
        data
    })
}

//个人简历添加
export function userResumeAdd(data) {
    return request({
        url: '/api/resume/saveResume',
        method: 'POST',
        data
    })
}


export function userResumeStatusUpdate(data) {
    return request({
        url: '/api/member/resume-public-status',
        method: 'POST',
        data
    })
}



//个人中心-投诉列表

export function userComplaintList(data) {
    return request({
        url: '/api/complaint/list',
        method: 'GET',
        params: data
    })
}

//个人中心-投诉详情

export function userComplaintInfo(data) {
    return request({
        url: '/web/user/complaint/info',
        method: 'GET',
        params: data
    })
}
///web/user/complaint/info


